/**
 * Documents API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  calculateDocumentPreview,
  deleteDocument,
  finalizeDocument,
  fiscalizeDocument,
  getNextDocumentNumber,
  getShareableId,
  permanentDeleteDocument,
  restoreDocument,
  sendDocument,
  shareDocument,
  unshareDocument,
} from "../generated/documents/documents";

import { wrapMethod } from "./utils";

export const documents = {
  /** @see getNextDocumentNumber */
  getNextNumber: wrapMethod(getNextDocumentNumber),

  /** @see calculateDocumentPreview */
  calculateDocumentPreview: wrapMethod(calculateDocumentPreview),

  /** @see finalizeDocument */
  finalizeDocument: wrapMethod(finalizeDocument),

  /** @see fiscalizeDocument */
  fiscalizeDocument: wrapMethod(fiscalizeDocument),

  /** @see deleteDocument */
  delete: wrapMethod(deleteDocument),

  /** @see restoreDocument */
  restoreDocument: wrapMethod(restoreDocument),

  /** @see permanentDeleteDocument */
  permanentDeleteDocument: wrapMethod(permanentDeleteDocument),

  /** @see sendDocument */
  sendDocument: wrapMethod(sendDocument),

  /** @see shareDocument */
  shareDocument: wrapMethod(shareDocument),

  /** @see getShareableId */
  getShareableId: wrapMethod(getShareableId),

  /** @see unshareDocument */
  unshareDocument: wrapMethod(unshareDocument),
} as const;

export type DocumentsApi = typeof documents;
